export const RECOVERY_HN_FILTER_WITH_HN = "with_hn";
export const RECOVERY_HN_FILTER_EMPTY = "empty_hn";
export const RECOVERY_HN_FILTER_ALL = "all";

const normalizeHn = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).trim();
};

const getFirstHn = (values) => {
  for (const value of values) {
    const normalizedValue = normalizeHn(value);
    if (normalizedValue) return normalizedValue;
  }

  return "";
};

export const getBookingRecoveryHn = (record = {}) => {
  const summary = record.summary || {};
  const booking = record.booking || {};
  const bookingProps = booking.extendedProps || {};

  return getFirstHn([
    summary.hn,
    bookingProps.hn,
    bookingProps.HN,
    booking.hn,
    booking.HN,
    record.hn,
    record.HN,
  ]);
};

export const getCpapTrialRecoveryHn = (record = {}) => {
  const summary = record.summary || {};
  const trial = record.trial || {};
  const trialProps = trial.extendedProps || {};

  return getFirstHn([
    summary.hn,
    trialProps.HN,
    trialProps.hn,
    trial.HN,
    trial.hn,
    record.HN,
    record.hn,
  ]);
};

export const filterRecoveryRecordsByHn = (
  records,
  hnFilter,
  getRecoveryHn,
) => {
  const sourceRecords = Array.isArray(records) ? records : [];

  if (hnFilter === RECOVERY_HN_FILTER_ALL) return sourceRecords;

  const showEmptyOnly = hnFilter === RECOVERY_HN_FILTER_EMPTY;
  return sourceRecords.filter((record) => {
    const hasHn = Boolean(getRecoveryHn(record));
    return showEmptyOnly ? !hasHn : hasHn;
  });
};
